export const generateRandomString = (): string => (Math.random() + 1).toString(36).substring(7);
export const isStringContainsLineBreak = (str?: unknown): boolean => {
    if (typeof str === 'string') {
        return str.includes('\n');
    }
    return false;
};
export const isStringContainsHTMLLineBreak = (str?: unknown): boolean => {
    if (typeof str === 'string') {
        return str.includes('<br>') || str.includes('<br/>');
    }
    return false;
};

export const stringifyRequestParams = <T extends Record<string, unknown>>(params?: T): Record<string, string> => {
    const requestParams: Record<string, string> = {};
    const inputParams = params || {};

    Object.keys(inputParams).forEach(k => {
        requestParams[k] = String(inputParams[k]);
    });

    return requestParams;
};

export const angularForEach = (obj, cb: (value, key) => void) => {
    Object.entries(obj).forEach(([key, value]) => {
        if (cb && typeof cb === 'function') {
            cb(value, key);
        }
    });
};
